module.exports = __webpack_public_path__ + "static/media/22.34792ad1.jpg";